<template>
    <div class="area-acoes">
        <az-call-to-action v-if="exibirBotaoLancarProposta"
                           :disabled="!value.estaNaEtapaPropostas"
                           @click="$emit('lancarProposta')"
                           :css-class="`botao-secundario${ !value.estaNaEtapaPropostas ? '-desabilitado' : '' } text-uppercase d-flex align-center`">
            <v-icon color="white">
                add_circle
            </v-icon>
            Lançar Proposta
        </az-call-to-action>

      <az-call-to-action
          v-if="exibirDataHoraInicioPropostas"
          disabled="true"
          css-class="mensagem-inicio-proposta d-flex align-center mx-2">
        <strong> Lançamento de propostas inicia em {{value.dataHoraInicioEnvioPropostas | az-date(humanizarFormatoDataHora(value.dataHoraInicioEnvioPropostas))}} </strong>.
      </az-call-to-action>

        <az-call-to-action v-if="exibirBotaoContinuarProposta"
                           :disabled="!value.estaNaEtapaPropostas"
                           @click="$emit('continuarProposta')"
                           :css-class="`botao-secundario${ !value.estaNaEtapaPropostas ? '-desabilitado' : '' } text-uppercase d-flex align-center`">
            <v-icon color="white">
                arrow_forward
            </v-icon>
            Continuar Proposta
        </az-call-to-action>

        <div v-show="exibirMensagemFaseDePropostasEncerrada" class="texto-proposta-encerrada">
            <p>
                Prazo para envio de propostas encerrado. <br>
                Compra encontra-se na etapa de lances, aguarde o encerramento para ver o resultado.
            </p>
        </div>

        <az-call-to-action v-if="exibirBotaoVerProtocolo"
                           @click="$emit('visualizarProtocolo')"
                           css-class="botao-secundario text-uppercase d-flex align-center">
            <v-icon color="white">
                search
            </v-icon>
            Ver Protocolo
        </az-call-to-action>

        <az-call-to-action v-if="exibirBotaoIrParaDisputa"
                           :disabled="exibirDataHoraInicioLances"
                           @click="$emit('visualizarDisputa')"
                           :css-class="`botao-secundario${ this.exibirDataHoraInicioLances ? '-desabilitado' : '' } text-uppercase d-flex align-center`">
            <v-icon color="white">
                arrow_forward
            </v-icon>
            Ir para Disputa
        </az-call-to-action>
        <az-call-to-action v-if="exibirBotaoIrParaDisputaFechada"
                           :key="`${value.id}-botao-diputa-fechada`"
                           @click="irParaDisputaFechada"
                           css-class="botao-secundario text-uppercase d-flex align-center mx-2">
            <v-icon color="white">
                arrow_forward
            </v-icon>
            Ir para Disputa Fechada
        </az-call-to-action>

        <az-call-to-action
                v-if="exibirDataHoraInicioLances"
                disabled="true"
                css-class="mensagem-inicio-lance d-flex align-center mx-2">
            <strong>Inicia em {{value.dataHoraInicioEnvioLances | az-date(humanizarFormatoDataHora(value.dataHoraInicioEnvioLances))}} </strong>.
        </az-call-to-action>

        <az-call-to-action v-if="exibirBotaoVerResultado"
                           @click="$emit('visualizarResultado')"
                           css-class="botao-secundario text-uppercase d-flex align-center">
            <v-icon color="white">
                search
            </v-icon>
            Ver Resultado
        </az-call-to-action>

        <div class="info-extra">

            <az-call-to-action v-if="exibirBotaoVerMinhaProposta"
                               @click="$emit('continuarProposta')"
                               css-class="botao-minha-proposta text-uppercase">
                Minha proposta
            </az-call-to-action>

            <p v-if="exibirBotaoVerProtocolo && false">
                <strong>Proposta Enviada:</strong> {{ value.dataProposta | az-date(humanizarFormatoDataHora(value.dataProposta)) }}
            </p>

            <p v-if="exibirBotaoVerProtocolo && false">
                <strong>Valor Total:</strong> {{ value.valorProposta | azCurrency }} &nbsp;&nbsp;|&nbsp;&nbsp;
                <strong>Itens:</strong> {{ value.totalItens }}
            </p>

            <p v-if="exibirBotaoIrParaDisputa && false">
                <strong>Lance Enviado:</strong> {{ value.dataLance | az-date(humanizarFormatoDataHora(value.dataLance)) }}
            </p>

            <p v-if="exibirBotaoIrParaDisputa && false">
                <strong>Situação:</strong>
                <span v-if="value.situacaoLance === 'PERDENDO'">
                    <i class="fas fa-thumbs-down" aria-hidden="true"/>
                    Perdendo
                </span>
                <span v-else>
                    <i class="fas fa-thumbs-up" aria-hidden="true"/>
                    Vencendo
                </span>
            </p>

            <a v-if="exibirBotaoVerResultado && !ehCompraPropostaManualEhAtiva"
               href="javascript:void(0)"
               :class="['botao-gerar-ata', { 'botao-gerar-ata--disabled': desabilitarBaixarAta }]"
               :aria-disabled="desabilitarBaixarAta"
               @click="!desabilitarBaixarAta && $emit('gerarRelatorioDaAta')">
                <i class="fas fa-download mr-1" aria-hidden="true"/> Baixar Ata
            </a>
        </div>
    </div>
</template>

<script>
import SmartTimerMixin from '@/core/mixins/SmartTimerMixin'
import {mapState} from 'vuex'

export default {
    name: 'DetalhesCompraDiretaAcoes',
    mixins: [SmartTimerMixin],
    props: {
        value: {
            required: true,
            default: {}
        }
    },
    computed: {
        ...mapState(['resumoCompraDireta', 'parametros']),
        exibirBotaoLancarProposta() {
            return this.value.situacao === 'ABERTA' && this.value.propostaSituacao === null && this.value.propostaId === null
        },
        exibirBotaoContinuarProposta() {
            return this.value.situacao === 'ABERTA' && this.value.propostaSituacao === 'EM_ELABORACAO' && this.value.propostaId !== null
        },
        exibirBotaoVerProtocolo() {
            return (this.value.situacao === 'ABERTA' || (this.value.situacao === 'SUSPENSA' && this.value.suspensaoPosAnalise === false))
                && this.value.propostaSituacao === 'ENVIADA' && this.value.tipo === 'SEM_DISPUTA'
        },
        exibirBotaoIrParaDisputa() {
            return this.value.situacao === 'ABERTA' && this.value.propostaSituacao === 'ENVIADA' && this.value.tipo === 'COM_DISPUTA'
        },
        exibirBotaoIrParaDisputaFechada() {
            return (['EM_ANALISE', 'REANALISE'].includes(this.value.situacao)
                && this.value.propostaSituacao === 'ENVIADA'
                 && this.value.possuiItemLoteEmDesempate)
        },
        exibirBotaoVerResultado() {
            return this.value.situacao === 'EM_ANALISE' || this.value.situacao === 'REANALISE' || this.value.situacao === 'ENCERRADA'
                || (this.value.situacao === 'SUSPENSA' && this.value.suspensaoPosAnalise === true)
        },
        exibirDataHoraInicioLances() {
            return this.value.propostaSituacao === 'ENVIADA' &&
                    this.value.tipo === 'COM_DISPUTA' &&
                    this.value.estaNaEtapaPropostas && !this.value.estaNaEtapaLances
        },
        exibirDataHoraInicioPropostas() {
            return this.value.situacao === 'AGUARDANDO_ABERTURA'
        },
        exibirBotaoVerMinhaProposta() {
            return this.value.propostaSituacao === 'ENVIADA' &&
                    this.value.estaNaEtapaPropostas && !this.value.estaNaEtapaLances
        },
        exibirMensagemFaseDePropostasEncerrada() {
            return !this.value.estaNaEtapaPropostas && (this.exibirBotaoLancarProposta || this.exibirBotaoContinuarProposta)
        },
        ehCompraPropostaManualEhAtiva() {
            return this.propostaManualAtiva && this.amparoLegalEhLei14133Art75VIII
        },
        propostaManualAtiva() {
            return Boolean(this.parametros.propriedadesCompraDiretas.propostaManual)
        },
        amparoLegalEhLei14133Art75VIII() {
            const lei = this.value?.amparoLegal?.lei || ''
            return typeof lei === 'string' && lei.includes('Lei 14.133/2021, Art. 75, VIII')
        },
    },
    mounted() {
        this.createSmartTimer('buscarDetalhesCompra', 'buscarDetalhesCompra', 10000, {
            autostart: true,
            immediate: true
        })
    },
    methods: {
        buscarDetalhesCompra() { this.$emit('buscarDetalhes') },
        irParaDisputaFechada(){
            this.$router.push({
                name: 'LanceDesempate',
                params: {id: this.value.id, propostaId: this.value.propostaId},
                query: this.$route.query
            })
        }
    }
}
</script>

<style scoped lang="stylus">
    .area-acoes
        display flex
        align-items center

    .area-acoes div:last-child
        margin-left auto

    .botao-secundario
        background-color var(--v-primary-base) !important
        border 0 !important
        color #fff !important
        padding 10px 15px
        margin-right 0

    .botao-secundario-desabilitado
        background-color #EBEBEB !important
        border 0 !important
        color #B8B8B8 !important
        padding 10px 15px
        margin-right 0
        pointer-events none

        i
            color #B8B8B8 !important

    .info-extra
        color #888
        margin-left 20px

        p
            margin-bottom 0

        span
            margin-left 5px

        .fa-thumbs-down
            color #d51652

        .fa-thumbs-up
            color var(--v-primary--text)

    .texto-proposta-encerrada
        color #777777
        text-align left
        font-size 13px
        margin-top 8px
        padding 0 15px

    .mensagem-inicio-lance
        color var(--v-primary-darken1) !important
        background-color var(--v-primary-lighten5) !important
        border 0 !important
        padding 10px 15px
        pointer-events none

    .mensagem-inicio-proposta
        color var(--v-primary-darken1) !important
        background-color var(--v-primary-lighten5) !important
        border 0 !important
        padding 10px 15px
        pointer-events none

    .botao-minha-proposta
        color #777 !important
        padding 10px 15px
        margin-right 0
        align-self flex-end !important

    .botao-gerar-ata
        color #777
        text-decoration none
        padding 5px 15px

        &:hover
            background-color #f5f5f5
            padding 5px 15px
</style>